// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2R0E8SBD53 wrapper wrapper_narrow","content":"_1qAr0XsePI"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/PasswordCreate/PasswordCreate.module.less
// module id = 963
// module chunks = 3